import { FusionAuthConfig } from "@fusionauth/react-sdk";

export const fusionAuthConfig: FusionAuthConfig = {
  clientID: import.meta.env.VITE_FUSIONAUTH_CLIENT_ID,
  serverUrl:
    import.meta.env.VITE_FUSIONAUTH_URL ?? "https://fusion-auth.authorify.com/",
  redirectUri: `${import.meta.env.VITE_BASE_URL}/app/callback`,
};
